<template>
  <div class="video">
    <video
      id="player-container-id"
      class="player"
      height="80%"
      playsinline
      preload="auto"
      webkit-playsinline
    ></video>
    <div
      v-if="Player"
      v-show="continuePlay === true"
      ref="continuePlayView"
      class="continuePlay cursor"
      @click="continuePlays"
    >
      上次播放到{{ $common.formatSeconds(chapterInfo.learn_log.second) }}，<span
        >继续播放</span
      >
    </div>
    <div
      v-if="Player"
      v-show="PlayerPaused === true"
      ref="pausedshowView"
      class="pausedshow"
    >
      <div class="msg">
        <icon-svg icon-class="zanting" />
        播放已暂停
      </div>
    </div>
  </div>
</template>

<script>
import { postStudyLearn } from '@/network/request'
export default {
  props: {
    chapterInfo: {
      type: Object,
      required: false,
      default: () => {},
    },
    dialogOpen: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      Player: null, // 播放器对象
      PlayerPaused: false, // 播放是否暂停
      continuePlay: false, // 控制续播盒子的显示与隐藏
      timeupdatenum: 0, //视频观看时间
    }
  },
  watch: {
    chapterInfo() {
      this.playerInit()
    },
  },
  destroyed() {
    if (this.Player) {
      if (this.timeupdatenum > 45) {
        this.saveLearningProgress()
      }
      this.Player.dispose()
      this.Player = null
    }
  },
  methods: {
    // 初始化播放器
    playerInit() {
      // 初始化播放器
      if (!this.Player) {
        this.Player = window.TCPlayer('player-container-id', {
          fileID: this.chapterInfo.video_media.fileID,
          appID: this.chapterInfo.video_media.appID,
          psign: this.chapterInfo.video_media.psign,
          autoplay: true,
          licenseUrl:
            'https://1301306766.trtcube-license.cn/license/v2/1301306766_1/v_cube.license',
        })
        this.Player.ready(() => {
          this.handleKeyCode()
          //   // 监听开始播放
          this.Player.on('play', () => {
            this.PlayerPaused = false
            // 保存学习记录
          })
          //监听正在播放状态
          this.Player.on('playing', () => {
            this.PlayerPaused = false
          })
          //  监听暂停
          this.Player.on('pause', () => {
            this.PlayerPaused = true
            //保存学习记录 播放时间大于10s且被暂停
            if (this.timeupdatenum >= 45) {
              this.saveLearningProgress()
            }
          })
          //监听播放位置

          this.Player.on('timeupdate', () => {
            // console.log(this.timeupdatenum++)
            this.timeupdatenum++
            if (this.timeupdatenum % 45 == 0) {
              this.saveLearningProgress()
            }
          })
          this.Player.on('loadedmetadata', () => {
            if (this.chapterInfo.learn_log.second > 0) {
              this.continuePlay = true
              setTimeout(() => {
                this.continuePlay = false
              }, 5000)
            }
          })

          if (document.getElementsByClassName('player').length > 0) {
            document
              .getElementsByClassName('player')[0]
              .appendChild(this.$refs.pausedshowView)
            document
              .getElementsByClassName('player')[0]
              .appendChild(this.$refs.continuePlayView)
          }
        })
      } else {
        this.Player.loadVideoByID({
          fileID: this.chapterInfo.video_media.fileID,
          appID: this.chapterInfo.video_media.appID,
          psign: this.chapterInfo.video_media.psign,
        })
        //重置视频播放时间
        this.timeupdatenum = 0
      }
    },
    // 续播功能 player
    continuePlays() {
      this.continuePlay = false
      this.Player.currentTime(this.chapterInfo.learn_log.second)
    },
    // 键盘事件
    handleKeyCode() {
      const that = this
      const cancelKeys = [32, 37, 38, 39, 40]
      window.addEventListener('keydown', (event) => {
        if (this.dialogOpen) return
        if (cancelKeys.indexOf(event.keyCode) >= 0) {
          event.stopPropagation()
          event.preventDefault()
        }
      })
      window.addEventListener('keyup', (event) => {
        if (this.dialogOpen) return
        if (cancelKeys.indexOf(event.keyCode) >= 0) {
          event.stopPropagation()
          event.preventDefault()
        }
        if (!that.Player) return false
        switch (event.keyCode) {
          case 32: {
            //space
            that.Player.paused() ? that.Player.play() : that.Player.pause()
            break
          }
          case 37: {
            //Left
            const target = that.Player.currentTime() - 10
            this.Player.currentTime(target < 0 ? 0 : target)
            break
          }
          case 39: {
            //Right
            const allTime = that.Player.duration()
            const target = that.Player.currentTime() + 10
            this.Player.currentTime(target > allTime ? allTime : target)
            break
          }
          case 38: {
            //Up
            const target = that.Player.volume() + 0.1
            this.Player.volume(target > 1 ? 1 : target)
            break
          }
          case 40: {
            //Down
            if (this.dialogOpen) return
            const target = that.Player.volume() - 0.1
            this.Player.volume(target < 0 ? 0 : target)
            break
          }
        }
        return true
      })
    },
    //保存学习进度
    async saveLearningProgress() {
      postStudyLearn({
        chapter_id: this.chapterInfo.id,
        second: this.Player.currentTime(),
      }).then((res) => {
        if (res.data.code == 0) {
          // console.log('保存进度成功')
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.video {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #000;
  overflow: hidden;

  .continuePlay {
    position: absolute;
    bottom: 70px;
    left: 10px;
    background-color: rgba(104, 104, 104, 0.5);
    width: 250px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    color: #fff;
    font-size: 14px;
    border-radius: 10px;

    span {
      color: #419cff;
    }
  }

  .player {
    width: 100%;
    height: 100%;
    // position: relative;
  }

  .pausedshow {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 9;
    pointer-events: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    .msg {
      font-size: 16px;
      padding: 20px;
      color: #fff;
      opacity: 0.9;

      .icon-svg {
        font-size: 18px;
        margin-right: 3px;
      }
    }
  }
}
</style>
